// Local translations
export const T = {
  en_GB: {
    selectFlowDescription: "Select a flow to start for this client",
    flows: "Flows",
    startFlow: "Start Flow",
    noFlowInstances: "No flow instances yet",
    startFirstFlow: "Start First Flow",
    noActiveFlows: "No active flows available. Create flows in Settings.",
    preview: "Preview",
    flow: "Flow",
    status: "Status",
    externalStatus: "External Status",
    signed: "Signed",
    lastUpdated: "Last updated",
    completed: "Completed",
    actions: "Actions",
    executed: "Executed",
    canceled: "Canceled",
    send: "Send",
    signedStatus: "Signed",
    waiting: "Waiting",
    cancelled: "Cancelled",
    expired: "Expired",
    failed: "Failed",
    view: "View",
    continue: "Continue",
    startNewFlow: "Start New Flow",
    deleteFlowInstance: "Delete Flow Instance",
    deleteConfirmation:
      "Are you sure you want to delete this flow instance? This action cannot be undone.",
    delete: "Delete",
    cancel: "Cancel",
    error: "Error",
    failedToStartFlow: "Failed to start flow",
    failedToDeleteInstance: "Failed to delete instance",
  },
  nb_NO: {
    selectFlowDescription: "Velg en flyt du vil starte for denne kunden",
    flows: "Flyter",
    startFlow: "Start flyt",
    noFlowInstances: "Ingen flytinstanser ennå",
    startFirstFlow: "Start første flyt",
    noActiveFlows: "Ingen aktive flyter tilgjengelig. Opprett flyter i Innstillinger.",
    preview: "Forhåndsvisning",
    flow: "Flyt",
    status: "Status",
    externalStatus: "Ekstern status",
    signed: "Signert",
    lastUpdated: "Sist oppdatert",
    completed: "Fullført",
    actions: "Handlinger",
    executed: "Utført",
    canceled: "Avbrutt",
    send: "Send",
    signedStatus: "Signert",
    waiting: "Venter",
    cancelled: "Kansellert",
    expired: "Utløpt",
    failed: "Feilet",
    view: "Vis",
    continue: "Fortsett",
    startNewFlow: "Start ny flyt",
    deleteFlowInstance: "Slett flytinstans",
    deleteConfirmation:
      "Er du sikker på at du vil slette denne flytinstansen? Denne handlingen kan ikke angres.",
    delete: "Slett",
    cancel: "Avbryt",
    error: "Feil",
    failedToStartFlow: "Kunne ikke starte flyt",
    failedToDeleteInstance: "Kunne ikke slette instans",
  },
} as const;
